export default __webpack_public_path__ + "static/media/ISKO CLASS-2 EXAM PATTERN 2026-27.66710aff.pdf";